import { useEffect } from 'react';
import { usePageMetadata } from '../../context/PageMetadataContext';

export default function useCreatorPageTitle(title) {
  const { setTitle, setShowTitleInHeader } = usePageMetadata();
  useEffect(() => { setTitle(title); setShowTitleInHeader(false); }, [title, setTitle, setShowTitleInHeader]);
}
